/**
 * 商品详情页面状态缓存
 */
import { useCallback } from 'react';
import {
  useReduceWithModel,
  IModel,
} from '@/hooks/useReduceWithModel/useReduceWithModel';

interface IState<T> {
  // 缓存是否可用标记
  enable: boolean;
  // 缓存数据，由于存在多种规格商品商品详情的状态，这里使用any类型
  data: T;
}

const initialState: IState<any> = {
  enable: false,
  data: undefined,
};

enum actionEnum {
  enable = 'enable',
  disable = 'disable',
  update = 'update',
}

/**
 * 可以直接返回state，也可以修改draft里面的数据，返回空
 * @param draft
 * @param action
 */

const model: IModel<IState<any>> = {
  immer: true,
  state: initialState,
  reducers: {
    [actionEnum.enable](state: IState<any>) {
      return {
        ...state,
        enable: true,
      };
    },
    [actionEnum.disable](state: IState<any>) {
      return {
        ...state,
        enable: false,
      };
    },
    [actionEnum.update](
      state: IState<any>,
      action: {
        [extraProps: string]: any;
      },
    ) {
      return {
        ...state,
        data: action.data,
      };
    },
  },
};

function useProductDetailCacheModal<T>() {
  const [state, dispatch] = useReduceWithModel<{ enable: boolean; data: T }>(
    model,
  );

  const enable = useCallback(() => {
    dispatch({
      type: actionEnum.enable,
    });
  }, [dispatch]);

  const disable = useCallback(() => {
    dispatch({
      type: actionEnum.disable,
    });
  }, [dispatch]);

  const update = useCallback(
    data => {
      dispatch({
        type: actionEnum.update,
        data,
      });
    },
    [dispatch],
  );

  return {
    state,
    enable,
    disable,
    update,
  };
}

export default useProductDetailCacheModal;
